import React from 'react';

import * as css from './TextArea.css';

export const TextArea = React.forwardRef((props, ref) => {
	return <textarea className={css.TextArea} {...props} ref={ref} />;
});
